import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { requireSignIn } from '../auth/gate';
import { HushedFrame } from '../screens/auth/HushedFrame';
import { AdminAppPage } from '../screens/mobile/AdminAppPage';
import { appRequest } from '../screens/mobile/mobile-words';

/** A value from the link as text; the router reads a value that looks like a number as one. */
const text = z.union([z.string(), z.number()]).transform(String).optional().catch(undefined);

const searchSchema = z.object({ challenge: text, state: text, redirect_uri: text });

/**
 * An admin signs Paige Mobile in to connect copiers (docs/engineering/mobile-capture.md, 4.4): the app
 * opens this with its PKCE challenge; signed in as everywhere else, on the sign-in pages' ground.
 */
export const Route = createFileRoute('/m/admin')({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, location }) => {
    await requireSignIn(context.auth, location.href);
  },
  component: RouteComponent,
});

function RouteComponent() {
  const search = Route.useSearch();
  return (
    <HushedFrame>
      <AdminAppPage request={appRequest(search)} />
    </HushedFrame>
  );
}
